/**
 * UI Constants for Solar + BESS Financial Model
 * Tab names, labels, and other UI-related constants
 */

/**
 * Application tab navigation
 */
export const TABS = [
    'Summary',
    'Basic Data',
    'Investment & Financing',
    'BESS Analysis',
    'Loan Repayment',
    'Total Cost',
    'Profit & Loss',
    'Balance Sheet',
    'EVA',
    'Charts',
    'Sensitivity Analysis',
    'Analytics',
    'README'
];

/**
 * Tab categories for grouping
 */
export const TAB_CATEGORIES = {
    OVERVIEW: ['Summary', 'Basic Data', 'README'],
    FINANCIAL_STATEMENTS: ['Investment & Financing', 'Loan Repayment', 'Total Cost', 'Profit & Loss', 'Balance Sheet', 'EVA'],
    ANALYSIS: ['Charts', 'Sensitivity Analysis', 'Analytics'],
    BESS: ['BESS Analysis']
};

/**
 * App metadata and text content
 */
export const APP_METADATA = {
    TITLE: 'Solar + BESS Financial Model',
    SUBTITLE: 'Comprehensive analysis for solar and battery energy storage projects.',
    FOOTER_TEXT: 'Ikutu - Sustainable Energy Solutions',
    VERSION: '1.0.0',
    AUTHOR: 'Ikutu Energy Solutions'
};

/**
 * Button tooltips and labels
 */
export const UI_LABELS = {
    IMPORT_TOOLTIP: 'Import Parameters',
    EXPORT_TOOLTIP: 'Export Parameters',
    PRINT_TOOLTIP: 'Print to PDF',
    DARK_MODE_TOOLTIP: 'Toggle Dark Mode',
    GOAL_SEEK_BUTTON: 'Run Goal Seek',
    GOAL_SEEK_LOADING: 'Finding Solution...',
    BESS_TOGGLE: 'Enable BESS Analysis'
};

/**
 * File upload configuration
 */
export const FILE_CONFIG = {
    ACCEPTED_TYPES: '.csv',
    MAX_FILE_SIZE: 1024 * 1024, // 1MB
    DEFAULT_EXPORT_FILENAME: 'solar_model_parameters.csv',
    DEFAULT_RESULTS_FILENAME: 'solar_model_results.csv'
};

/**
 * Default UI state values
 */
export const DEFAULT_UI_STATE = {
    ACTIVE_TAB: 'Summary',
    DARK_MODE: true,
    IS_LOADING_GOAL_SEEK: false,
    GOAL_SEEK_MESSAGE: ''
};

/**
 * Color scheme and styling constants
 */
export const UI_THEME = {
    COLORS: {
        PRIMARY: 'blue',
        SUCCESS: 'green',
        WARNING: 'yellow',
        DANGER: 'red',
        INFO: 'purple'
    },
    ICON_SIZE: 20,
    CONTAINER_CLASSES: 'container mx-auto p-4 sm:p-6 lg:p-8',
    HEADER_CLASSES: 'mb-6 flex justify-between items-center no-print relative',
    MAIN_CLASSES: 'bg-white dark:bg-gray-800 p-4 sm:p-6 rounded-b-lg shadow-lg printable-area'
};

/**
 * Responsive breakpoints
 */
export const BREAKPOINTS = {
    SM: '640px',
    MD: '768px',
    LG: '1024px',
    XL: '1280px'
};

/**
 * Animation and transition constants
 */
export const ANIMATIONS = {
    TAB_TRANSITION: 'transition-all duration-200',
    BUTTON_TRANSITION: 'transition-colors',
    LOADING_ANIMATION: 'animate-spin'
};

/**
 * Print-specific constants
 */
export const PRINT_CONFIG = {
    EXCLUDED_TABS: ['README'],
    PAGE_MARGIN: '1in',
    PAPER_SIZE: 'letter',
    FONT_SIZE: {
        BASE: '12px',
        H1: '24px',
        H2: '18px',
        H3: '16px'
    }
}; 